/**
 * Avatar URL for the *other* participant in a mail thread (sender/receiver join).
 * @param {object} mail — row from mailmessage (+ sender_avatar, receiver_avatar from API)
 * @param {string|number} myUserId — logged-in users.id
 * @returns {string|null}
 */
export function contactAvatarUrl(mail, myUserId) {
  if (!mail || myUserId == null || myUserId === "") return null;
  const me = String(myUserId).trim();
  const sid = mail.sender_id != null ? String(mail.sender_id).trim() : "";
  const rid = mail.receiver_id != null ? String(mail.receiver_id).trim() : "";

  let url = null;
  if (sid && sid === me) url = mail.receiver_avatar;
  else if (rid && rid === me) url = mail.sender_avatar;
  else url = mail.sender_avatar || mail.receiver_avatar;

  if (url != null && String(url).trim() !== "") return String(url).trim();
  return null;
}

export function avatarInitial(label) {
  return (label || "?").trim().slice(0, 1).toUpperCase() || "?";
}
